var map = {
	"./foka.jpg": "4511",
	"./gitara.jpg": "662c",
	"./hulajnoga.jpg": "8504",
	"./igla.jpg": "2bbe",
	"./jajko.jpg": "1caa",
	"./kot.jpg": "1f2e",
	"./lampa.jpg": "7240",
	"./mrowka.jpg": "0a1e",
	"./nozyczki.jpg": "b767",
	"./okulary.jpg": "19a5",
	"./papuga.jpg": "0955",
	"./rak.jpg": "1837",
	"./slon.jpg": "73c8",
	"./tulipan.jpg": "6a8a",
	"./ul.jpg": "5e12",
	"./waz.jpg": "d70a",
	"./zegar.jpg": "6c24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5252";